export const NotificationsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Тема',
        key: 'subject',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Тип',
        key: 'type',
    },
]

export const NotificationItColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Название уведомления',
        key: 'title',
    },
    {
        name: 'Тип',
        key: 'channel',
    },
    {
        name: 'Компании',
        key: 'companiesString',
        withHint: true,
    },
    {
        name: 'Описание',
        key: 'description',
        withHint: true,
    },
]
